import * as React from 'react';
import { PriceType } from "../../../classes/price-type"
import Toggle from "../../../common/toggle/toggle"
import CheckboxGroup from "../../../common/checkbox/checkbox-group"
import { SeatingOption, IOptionGroup, IOption } from '../../../classes/seating-option';
import { sortPriceTypes } from '../../../helpers/price-type-helpers';

interface IPriceTypeFilterProps {
    priceTypes: Array<PriceType>
    onPriceTypeToggle: (selectedOptions: IOption[]) => void;
    selectedPriceTypeIds: Array<string>;
    description: string;
    allTicketsText: string;
}

export default class PriceTypeFilter extends React.PureComponent<IPriceTypeFilterProps, {}> {

    private priceTypeOptions: Array<IOption>;

    constructor(props: IPriceTypeFilterProps) {
        super(props);

        this.priceTypeOptions = this.getSortedPriceTypes(props.priceTypes).map(priceType => {
            let opt: IOption = {
                id: priceType.priceTypeId.toString(),
                name: priceType.title,
                selected: props.selectedPriceTypeIds.indexOf(priceType.priceTypeId.toString()) >= 0
            };
            return opt;
        });
    }

    getSortedPriceTypes(pts: Array<PriceType>) {
        return sortPriceTypes(pts);
    }

    render() {
        return (
            <div className="price-type-filter">
                <div className="price-type-filter-list">
                    {
                        <CheckboxGroup group={{
                            options: this.priceTypeOptions,
                            name: "priceTypeFilter"
                        } as IOptionGroup}
                            allText={this.props.allTicketsText}
                            showAllOption={true}
                            selectedOptions={this.priceTypeOptions.filter(option => this.props.selectedPriceTypeIds.indexOf(option.id) >= 0)}
                            stateChangeFunction={this.props.onPriceTypeToggle} id={null} />
                    }
                </div>
            </div>
        )
    }
}